//@ts-nocheck
import { Col, Row } from "antd";
import { motion } from "framer-motion";
import GoogleMapReact from "google-map-react";
import React from "react";
import { FaAddressBook, FaBath, FaBed } from "react-icons/fa";
import { GiCook } from "react-icons/gi";
import { MdCall } from "react-icons/md";
import "react-image-gallery/styles/css/image-gallery.css";
import { useLocation } from "react-router-dom";
import {
  componentTransition,
  componentTransitionProp,
} from "../../animation/index";
import { Back, SmallMapContainer } from "../../globalComponents/globalStyle";
import { ClusterContainer } from "../Locate/Style";
import { Error } from "../Post/style";
import {
  Amenities,
  Contact,
  Description,
  DetailsContainer,
  InfoItem,
  MoreDetails,
  MoreInfoContainer,
} from "./style";
const Details = () => {
  const styles = {
    height: "50%",
  };
  const location: any = useLocation();
  const [imageList, setImageList] = React.useState([]);
  console.log("the location is", location.state);

  const Marker: React.FC<any> = ({ children }) => (
    <div
      style={{
        padding: "1px",
        color: "white",
        background: "none",
        width: "fitContent",
      }}
    >
      {children}
    </div>
  );
  const pic = React.useMemo(() => {
    let imageId;
    let imageIndex;
    const imageArray = location?.state?.accomodation?.images?.map(
      (image, id) => {
        const imageArray = image.split("/")[3];
        if (imageArray) {
          if (!imageId) {
            imageId = +imageArray;
            imageIndex = +id;
          }
          imageId = +imageId > +imageArray ? +imageId : +imageArray;
          imageIndex = +imageId > +imageArray ? +imageIndex : +id;
        }
      }
    );
    return location?.state?.accomodation?.images[imageIndex];
  }, [location?.state?.accomodation?.images]);
  // console.log("images", pic);
  // console.log("id", imageIndex);
  // console.log(imageId);

  const images = location?.state?.accomodation?.photolink?.map(
    (img: string) => ({ original: img, thumbnail: img })
  );
  console.log("images", images);
  return (
    <motion.div
      variants={componentTransition}
      initial="initial"
      animate="in"
      exit="out"
      transition={componentTransitionProp}
    >
      <Back />
      <DetailsContainer>
        <Row style={{ height: "100%" }} justify="space-between">
          <Col md={{ span: 12 }} style={{ height: "100%" }}>
            <SmallMapContainer style={{ height: "100%" }}>
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: process.env.REACT_APP_GOOGLE_KEY as string,
                }}
                defaultCenter={{
                  lat: Number(location?.state?.accomodation?.latitude),
                  lng: Number(location?.state?.accomodation?.longitude),
                }}
                defaultZoom={20}
                yesIWantToUseGoogleMapApiInternals
              >
                <Marker
                  lat={Number(location?.state?.accomodation?.latitude)}
                  lng={Number(location?.state?.accomodation?.longitude)}
                >
                  <ClusterContainer>location</ClusterContainer>
                </Marker>
              </GoogleMapReact>
            </SmallMapContainer>
          </Col>
          <Col md={{ span: 12 }} style={{ height: "100%" }}>
            <MoreInfoContainer style={{ height: "100%" }}>
              <div style={{ height: "50%" }}>
                <MoreDetails>
                  {/* {location?.state?.accomodation?.photolink} */}
                  {location?.state?.accomodation?.images?.length === 0 ||
                    (location?.state?.accomodation?.images === null && (
                      <Error>Image currently unavailable.</Error>
                    ))}
                  {/* <Error>Currently unavailable</Error> */}
                  {/* {location?.state?.accomodation?.photolink?.length > 0 && (
                  <ImageGallery
                    showBullets={true}
                    showPlayButton={false}
                    disableThumbnailScroll={true}
                    items={images}
                    additionalClass={styles.height}
                  />
                )} */}
                  <img
                    src={pic}
                    height="100%"
                    width="100%"
                    alt="accomodation"
                  />
                </MoreDetails>
              </div>
              <div style={{ height: "50%" }}>
                <MoreDetails>
                  <Contact>
                    <div>
                      <h2>
                        Agent name :{" "}
                        {location?.state?.accomodation?.agent_name ||
                          "data unavailable"}
                      </h2>
                    </div>
                    <div>
                      <h4>
                        <span>
                          <MdCall />:
                        </span>{" "}
                        {location?.state?.accomodation?.agent_phone}
                      </h4>
                      <h4>
                        <span>
                          <FaAddressBook />:
                        </span>
                        {location?.state?.accomodation?.agent_address}
                      </h4>
                    </div>
                  </Contact>
                  <br />
                  <div>
                    <InfoItem style={{ textAlign: "start" }}>
                      <Amenities>
                        <h1>Accomodation Details</h1>
                      </Amenities>
                      {/* <h4> Location</h4> */}
                      <h2>
                        address:{" "}
                        {location?.state?.accomodation?.displayable_address}
                      </h2>
                      <h2>
                        {" "}
                        post town: {location?.state?.accomodation?.post_town}
                      </h2>
                      <h2>
                        country:{" "}
                        {location?.state?.accomodation?.address?.country}
                      </h2>
                    </InfoItem>
                  </div>
                  <br />
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <InfoItem>
                      <h4>Bed Room</h4>
                      <h1>
                        {location?.state?.accomodation?.num_bedrooms}{" "}
                        <span>
                          <FaBed />
                        </span>{" "}
                      </h1>
                    </InfoItem>
                    <InfoItem>
                      <h4>BathRoom</h4>
                      <h1>
                        {location?.state?.accomodation?.num_bathrooms}{" "}
                        <span>
                          <FaBath />
                        </span>{" "}
                      </h1>
                    </InfoItem>
                    <InfoItem>
                      <h4>Kitchen</h4>
                      <h1>
                        <span>
                          <GiCook />
                        </span>{" "}
                      </h1>
                    </InfoItem>
                    <InfoItem>
                      <h4>Property Type</h4>
                      <h1>{location?.state?.accomodation?.property_type} </h1>
                    </InfoItem>
                  </div>
                  {/* <Amenities>
                    <h1>Amenities</h1>
                    <div>
                      {location?.state?.accomodation?.amenities?.map(
                        (amenity: any) => (
                          <h3>{amenity}</h3>
                        )
                      )}
                    </div>
                  </Amenities>
                  <br /> */}

                  <Amenities>
                    <h1>Furnished State</h1>
                    <div>
                      <h3>
                        {" "}
                        {location?.state?.accomodation?.furnished_state || ""}
                      </h3>
                    </div>
                  </Amenities>
                  <br />
                  <Amenities>
                    <h1>Pricing</h1>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* <br /> */}
                      <InfoItem>
                        <h2>
                          Currency:
                          {location?.state?.accomodation?.currency}
                        </h2>
                      </InfoItem>
                      <InfoItem>
                        <h2>
                          Amount:
                          {location?.state?.accomodation?.rental_prices
                            ?.per_week / 100}
                        </h2>
                      </InfoItem>
                      <InfoItem>
                        <h2>
                          Status:
                          {location?.state?.accomodation?.listing_status}
                        </h2>
                      </InfoItem>
                    </div>
                  </Amenities>
                  <Description>
                    <br />
                    <h4>Description</h4>
                    <h1>{location?.state?.accomodation?.description}</h1>
                  </Description>
                </MoreDetails>
              </div>
            </MoreInfoContainer>
          </Col>
        </Row>
      </DetailsContainer>
    </motion.div>
  );
};
export default Details;
